import { TranscodingManagerActionTypes } from '../actions';
import { TranscodingManagerStoreModel } from '../initial.state';

export const TranscodingManagerReducer = (
  state = new TranscodingManagerStoreModel(),
  { type, payload }
) => {
  switch (type) {
    case TranscodingManagerActionTypes.GET_TOBE_RE_TRANSCODED_JOBS: {
      return {
        ...state,
        toBeReTranscodedJobs: payload,
      };
    }

    case TranscodingManagerActionTypes.GET_TOBE_TRANSCODED_JOBS: {
      return {
        ...state,
        tobeTranscodedJobs: payload,
      };
    }

    case TranscodingManagerActionTypes.GET_CANCELLED_JOBS: {
      return {
        ...state,
        cancelledJobs: payload,
      };
    }

    case TranscodingManagerActionTypes.GET_ADDITIONAL_CANCELLED_JOBS: {
      return {
        ...state,
        cancelledJobs: {
          Jobs: [...state.cancelledJobs.Jobs, ...payload.Jobs],
          NextToken: payload.NextToken,
        },
      };
    }

    case TranscodingManagerActionTypes.GET_ERRORED_JOBS: {
      return {
        ...state,
        erroredJobs: payload,
      };
    }

    case TranscodingManagerActionTypes.GET_ADDITIONAL_ERRORED_JOBS: {
      return {
        ...state,
        erroredJobs: {
          Jobs: [...state.erroredJobs.Jobs, ...payload.Jobs],
          NextToken: payload.NextToken,
        },
      };
    }

    case TranscodingManagerActionTypes.GET_SUBMITTED_JOBS: {
      return {
        ...state,
        submittedJobs: payload,
      };
    }

    case TranscodingManagerActionTypes.GET_ADDITIONAL_SUBMITTED_JOBS: {
      return {
        ...state,
        submittedJobs: {
          Jobs: [...state.submittedJobs.Jobs, ...payload.Jobs],
          NextToken: payload.NextToken,
        },
      };
    }

    case TranscodingManagerActionTypes.GET_RUNNING_JOBS: {
      return {
        ...state,
        runningJobs: payload,
      };
    }

    case TranscodingManagerActionTypes.GET_ADDITIONAL_RUNNING_JOBS: {
      return {
        ...state,
        runningJobs: {
          Jobs: [...state.runningJobs.Jobs, ...payload.Jobs],
          NextToken: payload.NextToken,
        },
      };
    }

    case TranscodingManagerActionTypes.GET_FINISHED_JOBS: {
      return {
        ...state,
        finishedJobs: payload,
      };
    }

    case TranscodingManagerActionTypes.GET_ADDITIONAL_FINISHED_JOBS: {
      return {
        ...state,
        finishedJobs: {
          Jobs: [...state.finishedJobs.Jobs, ...payload.Jobs],
          NextToken: payload.NextToken,
        },
      };
    }

    case TranscodingManagerActionTypes.UPDATE_TRANSCODING_SUCCESS: {
      return {
        ...state,
        isTranscodingSuccess: `${payload}-${new Date()}`,
      };
    }

    default: {
      return state;
    }
  }
};
